// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__DRw2q","logoMove":"Logo_logoMove__1Czah","logoTitle":"Logo_logoTitle__j_C7J"};